module.exports = __webpack_public_path__ + "img/s-fold.caf100e7.svg";